import {
  Roles,
  RolesOutput,
} from "../models/autogenerated-deliveryService-gql/graphql";

export type NormalizedRoles = {
  activeRole: Roles | null;
  assignedRoles: Roles[];
};

const ROLE_SORT_ORDER: Roles[] = [
  Roles.Carrier,
  Roles.Customer,
  Roles.Supplier,
  Roles.System,
];

const compareRolesAlphabetically = (left: Roles, right: Roles): number => {
  return left.localeCompare(right);
};

const sortUniqueRoles = (roles: Roles[]): Roles[] => {
  return Array.from(new Set(roles)).sort(compareRolesAlphabetically);
};

export const splitRole = (role: Roles): Roles[] => {
  switch (role) {
    case Roles.SupplierAndCarrier:
      return [Roles.Supplier, Roles.Carrier];
    case Roles.SupplierAndCustomer:
      return [Roles.Supplier, Roles.Customer];
    case Roles.AllRoles:
      return ROLE_SORT_ORDER;
    case Roles.None:
      return [];
    case Roles.Supplier:
    case Roles.Carrier:
    case Roles.Customer:
    case Roles.System:
      return [role];
    default:
      return [];
  }
};

export const normalizeRolesOutput = (
  rolesOutput: RolesOutput | null,
): NormalizedRoles => {
  if (!rolesOutput) {
    return {
      activeRole: null,
      assignedRoles: [],
    };
  }

  const assignedRoles = sortUniqueRoles(
    rolesOutput.assignedRoles.flatMap((role) => splitRole(role)),
  );

  const splitActiveRole = splitRole(rolesOutput.activeRole);
  const activeRole =
    splitActiveRole.find((role) => assignedRoles.includes(role)) ||
    assignedRoles[0] ||
    null;

  return {
    activeRole,
    assignedRoles,
  };
};

// unused — kept public only if callers import it.
export const getAlphabeticallyFirstRole = (roles: Roles[]): Roles | null => {
  const sorted = sortUniqueRoles(roles.flatMap((role) => splitRole(role)));
  return sorted[0] || null;
};
